import { useEffect, useRef, useContext, useState } from "react"
import Demographics from "../../GPRAForms/Forms/A/Demographics/Demographics"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const DemographicsContainer = ({ showToolBar, disabled, interview_id }) => {
  const { interview, handleSubmitGet, loadCollection, handleLoadPrev } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)

  const [isGettingDemographics, setIsGettingDemographics] = useState(true)

  const toast = useRef()
  useEffect(() => {
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      setIsGettingDemographics(true)
      handleSubmitGet(endpoints.GET_DEMOGRAPHICS_DATA, {
        gpra_interview_id: !interview_id
          ? interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id
          : interview_id,
        organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.DEMOGRAPHICS,
      })
        .then((response) => {
          if (response.status === 204 || response.status === 200) {
            loadCollection(
              setValues(response.data),
              INTERVIEW_SECTIONS.DEMOGRAPHICS
            )
            handleLoadPrev(false)
            setIsGettingDemographics(false)
          }
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingDemographics(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_a_demo_q1: data?.form?.gpraADemoQ1 ?? "",
      gpra_a_demo_q1a: data?.form?.gpraADemoQ1a ?? "",
      gpra_a_demo_q2: data?.form?.gpraADemoQ2 ?? "",
      gpra_a_demo_q2_a: loadEthnics(data?.form),
      gpra_a_demo_q3: loadRaces(data?.form),
      gpra_a_demo_q3p2: data?.form?.gpraADemoQ3p2 ?? "",
      gpra_a_demo_q4:
        data?.form?.gpraADemoQ4 && new Date(data?.form?.gpraADemoQ4),
      gpra_a_demo_q4a: data?.form?.gpraADemoQ4a ?? "",
      gpra_a_demo_q5: data?.form?.gpraADemoQ5 ?? undefined,
      gpra_a_demo_q5a: data?.form?.gpraADemoQ5a ?? "",
      gpra_a_demo_q5b: data?.form?.gpraADemoQ5b ?? "",
      gpra_a_demo_q6: data?.form?.gpraADemoQ6 ?? "",
      gpra_a_demo_q6a: data?.form?.gpraADemoQ6a ?? "",
      gpra_a_demo_q7: data?.form?.gpraADemoQ7 ?? "",
      gpra_a_demo_q8: data?.form?.gpraADemoQ8 ?? "",
      gpra_a_demo_q9: data?.form?.gpraADemoQ9 ?? "",
      gpra_a_demo_q9a: data?.form?.gpraADemoQ9a ?? 0,
      gpra_a_demo_q9ab: data?.form?.gpraADemoQ9ab ?? false,
      gpra_a_demo_q9b: data?.form?.gpraADemoQ9b ?? "",
      gpra_a_demo_q9ba: data?.form?.gpraADemoQ9ba ?? 0,
      gpra_a_demo_q9c: data?.form?.gpraADemoQ9c ?? "",
      gpra_a_demo_q9ca: data?.form?.gpraADemoQ9ca ?? 0,
      gpra_a_demo_q10: data?.form?.gpraADemoQ10 ?? "",
      gpra_a_demo_q11: data?.form?.gpraADemoQ11 ?? "",
      additional: data?.additional ?? [],
      gpra_a_demo_id: data?.form?.gpraADemoId ?? 0,
    }
  }
  const loadRaces = (data) => {
    let races = []
    data?.gpraADemoQ3a && races.push(data.gpraADemoQ3a)
    data?.gpraADemoQ3b && races.push(data.gpraADemoQ3b)
    data?.gpraADemoQ3c && races.push(data.gpraADemoQ3c)
    data?.gpraADemoQ3d && races.push(data.gpraADemoQ3d)
    data?.gpraADemoQ3e && races.push(data.gpraADemoQ3e)
    data?.gpraADemoQ3f && races.push(data.gpraADemoQ3f)
    data?.gpraADemoQ3g && races.push(data.gpraADemoQ3g)
    data?.gpraADemoQ3h && races.push(data.gpraADemoQ3h)
    data?.gpraADemoQ3i && races.push(data.gpraADemoQ3i)
    data?.gpraADemoQ3j && races.push(data.gpraADemoQ3j)
    data?.gpraADemoQ3k && races.push(data.gpraADemoQ3k)
    data?.gpraADemoQ3l && races.push(data.gpraADemoQ3l)
    data?.gpraADemoQ3m && races.push(data.gpraADemoQ3m)
    data?.gpraADemoQ3n && races.push(data.gpraADemoQ3n)
    data?.gpraADemoQ3o && races.push(data.gpraADemoQ3o)
    data?.gpraADemoQ3p && races.push(data.gpraADemoQ3p)
    data?.gpraADemoQ3q && races.push(data.gpraADemoQ3q)
    return races
  }
  const loadEthnics = (data) => {
    let ethnics = []
    data?.gpraADemoQ2a && ethnics.push(data.gpraADemoQ2a)
    data?.gpraADemoQ2b && ethnics.push(data.gpraADemoQ2b)
    data?.gpraADemoQ2c && ethnics.push(data.gpraADemoQ2c)
    data?.gpraADemoQ2d && ethnics.push(data.gpraADemoQ2d)
    data?.gpraADemoQ2e && ethnics.push(data.gpraADemoQ2e)
    data?.gpraADemoQ2f && ethnics.push(data.gpraADemoQ2f)
    data?.gpraADemoQ2g && ethnics.push(data.gpraADemoQ2g)
    return ethnics
  }
  if (isGettingDemographics) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingDemographics && (
        <Demographics showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default DemographicsContainer
